<script setup lang="ts">
  import { computed } from 'vue';

  import { Badge } from '@ui/components/badge';
  import type { BadgeVariants } from '@ui/components/badge';
  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';
  import { cn } from '@ui/utils/utils';

  interface Props {
    currencies?: string[];
    size?: BadgeVariants['size'];
    variant?: BadgeVariants['variant'];
    withLabel?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    withLabel: false,
    size: 'md',
    variant: 'warning',
    currencies: () => [],
  });

  const label = 'FX';

  const tooltipText = computed(() => {
    if (props.currencies.length > 0) {
      return `Foreign exchange: Payment involves ${props.currencies.join(', ')}`;
    }
    return 'Foreign exchange: Payment received in different currency than invoices';
  });
</script>

<template>
  <Tooltip>
    <TooltipTrigger>
      <Badge v-bind="$attrs" :variant :size>
        <i :class="cn('fa far fa-coins')" />
        <span v-if="withLabel"> {{ label }} </span>
      </Badge>
    </TooltipTrigger>

    <TooltipContent>
      {{ tooltipText }}
    </TooltipContent>
  </Tooltip>
</template>
